import { __assign } from "tslib";
import * as React from 'react';
import CoreCheckout from '../../../../core/src/Checkout/components/Checkout/Checkout';
var Checkout = function (props) { return React.createElement(CoreCheckout, __assign({ scrollTopOnStep: true }, props)); };
export default Checkout;
